import { AlertTriangle, ArrowRight, CheckCircle2, Factory, Radio, Wifi, WifiOff } from "lucide-react";
import { TechnicalMobileSetup } from "./TechnicalMobileSetup";
import { CallCard, CriticalCall, TeamPanel } from "./technical/TechnicalBoardCards";
import { clockLabel, dateLabel } from "./technical/technical-board-model";
import { useTechnicalBoardWorkspace } from "./technical/useTechnicalBoardWorkspace";
export type { TechnicalBoardCall } from "./technical/technical-board-model";
import "./technical-department-board.css";

export default function TechnicalDepartmentBoard() {
const { demoMode, items, team, now, lastUpdatedAt, loading, error, criticalCall, queuedItems, stoppedCount, unassignedCount, connectionProblem }=useTechnicalBoardWorkspace();
return (
    <main className="technical-board-shell">
      <header className="technical-board-header">
        <div className="technical-board-brand">
          <img src="/anl-logo-new-2026.webp" alt="ANL" />
          <span>
            <small>TEKNİK DEPARTMAN</small>
            <h1>Teknik Operasyon Merkezi</h1>
          </span>
        </div>
        <div className="technical-board-shift">
          <small>AKTİF VARDİYA</small>
          <strong>{new Date(now).getHours() < 8 ? "1. Vardiya" : new Date(now).getHours() < 16 ? "2. Vardiya" : "3. Vardiya"}</strong>
        </div>
        <div className="technical-board-summary" aria-label="Teknik çağrı özeti">
          <span><small>AÇIK ÇAĞRI</small><strong>{items.length}</strong></span>
          <span className={unassignedCount ? "is-critical" : ""}><small>SAHİPSİZ</small><strong>{unassignedCount}</strong></span>
          <span className={stoppedCount ? "is-critical" : ""}><small>DURAN HAT</small><strong>{stoppedCount}</strong></span>
        </div>
        <div className="technical-board-time">
          <strong>{clockLabel(new Date(now))}</strong>
          <span>{dateLabel(new Date(now))}</span>
          <small className={connectionProblem ? "is-offline" : ""} role="status">
            {connectionProblem ? <WifiOff aria-hidden="true" /> : <Wifi aria-hidden="true" />}
            {demoMode ? "Sunum verisi" : connectionProblem ? "Veri güncel değil" : "Canlı bağlantı"}
          </small>
        </div>
      </header>

      <TechnicalMobileSetup />

      {error ? (
        <div className="technical-board-connection-warning" role="alert">
          <AlertTriangle aria-hidden="true" />
          <span>
            <strong>Teknik çağrı verisi güncellenemiyor</strong>
            <small>{items.length ? "Son başarılı veri ekranda tutuluyor." : error}</small>
          </span>
        </div>
      ) : null}

      <section className="technical-board-command" aria-busy={loading}>
        {criticalCall ? <CriticalCall item={criticalCall} now={now} /> : (
          <div className="technical-board-all-clear">
            <CheckCircle2 aria-hidden="true" />
            <span><strong>Açık teknik çağrı yok</strong><small>Tüm makineler için teknik çağrı kuyruğu temiz.</small></span>
          </div>
        )}
        <div className="technical-board-command-grid">
          <section className="technical-board-queue" aria-label="Diğer açık teknik çağrılar">
            <header>
              <div><span>Açık çağrı kuyruğu</span><small>Etki ve bekleme süresine göre sıralı</small></div>
              <strong>{queuedItems.length}</strong>
            </header>
            <div className="technical-board-queue-list">
              {queuedItems.length ? queuedItems.map((item) => <CallCard item={item} now={now} key={item.id} />) : (
                <div className="technical-board-empty"><CheckCircle2 aria-hidden="true" /><strong>Başka açık çağrı yok</strong></div>
              )}
            </div>
          </section>
          <TeamPanel members={team} />
        </div>
      </section>

      <footer className="technical-board-footer">
        <span><Radio aria-hidden="true" /> Durumlar 15 saniyede bir güncellenir</span>
        <span><Factory aria-hidden="true" /> Üstlenme ve sonuç girişi ilgili makinenin terminalinden yapılır <ArrowRight aria-hidden="true" /></span>
        <span>Son veri: {lastUpdatedAt ? clockLabel(new Date(lastUpdatedAt)) : "Henüz alınmadı"}</span>
      </footer>
    </main>
  );
}
